var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"ci-action-icon-wrapper js-ci-status-icon",attrs:{"data-method":_vm.actionMethod,"title":_vm.tooltipText,"href":_vm.link,"rel":"nofollow","data-container":"body","aria-label":"Job's action"}},[_c('icon',{attrs:{"name":_vm.actionIcon}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c8772c4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/dropdown_action_component.vue
// module id = null
// module chunks = 